{
  "instances": {
    "configprops": {
      "label": "Configuration Properties",

      "no_properties_set": "No properties set"
    }
  }
}
